<template>
  <div class="content">
    <h1 class="has-text-centered">Asymmetrische Verschlüsselung</h1>
    <div class="box">
      <p>Ein paar Worte zur asymmetrischen Verschlüsselung.</p>
      <h2>Was ist eine asymmetrische Verschlüsselung?</h2>
      <ul>
        <li>
          Im Gegensatz zur symmetrischen Verschlüsselung arbeitet die asymmetrische Verschlüsselung mit
          <b>zwei Schlüsseln</b>
          (einen privaten und einen öffentlichen Schlüssel)&nbsp;statt einem
        </li>
        <li>
          Auch auch
          <b>Public-Key-Verfahren</b>
          bezeichnet
        </li>
      </ul>
      <h2>Das Prinzip der asymmetrischen Verschlüsselung</h2>
      <ul>
        <li>Arbeitet mit Schlüsselpaaren aus ..</li>
        <ul>
          <li>
            .. öffentlicher Schlüssel (
            <i>Public Key</i>
            )
          </li>
          <li>
            .. privater Schlüssel (
            <i>Private Key</i>
            )
          </li>
        </ul>
      </ul>
      <ul>
        <li>Daten welche mit einem öffentlichen Schlüssel verschlüsselt wurden können nur mit dem dazugehörigen privaten Schlüssel entschlüsselt werden</li>
        <li>Der private Schlüssel muss daher vom Besitzer geheim gehalten werden</li>
      </ul>
      <ul>
        <li><b>Funktionsweise</b></li>
        <ul>
          <li>Absender möchte Daten verschlüsselt an Empfänger senden</li>
          <li>Absender verschlüsselt die Daten mit dem öffentlichen Schlüssel des Empfängers</li>
          <li>Nur der Empfänger mit seinem privaten Schlüssel kann die verschlüsselten Daten wieder entschlüsseln</li>
        </ul>
      </ul>
      <ul>
        <li><b>Anwendung als Authentifizierung</b></li>
        <ul>
          <li>Sender verschlüsselt Nachricht zuerst mit seinem privaten und anschließend mit dem öffentlichen Schlüssel des Empfängers</li>
          <li>Nach Erhalt entschlüsselt der Empfänger den Schlüssel zuerst mit seinem privaten Schlüssel und anschließend mit dem öffentlichen Schlüssel des Senders</li>
        </ul>
      </ul>
    </div>
    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'

export default {
  name: 'theory-asymmetric-encryption',
  components: {
    FeedbackBox
  },
  metaInfo: {
    title: 'Asymmetrische Verschlüsselung | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Lorem Ipsum'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  }
}
</script>
